import { render } from "./pendingList.vue?vue&type=template&id=18fd865c&scoped=true"
import script from "./pendingList.vue?vue&type=script&lang=js"
export * from "./pendingList.vue?vue&type=script&lang=js"

import "./pendingList.vue?vue&type=style&index=0&id=18fd865c&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fd865c"]])

export default __exports__